import React from 'react';
import Icon, { IconProps } from './Icon';

/**
 * User icon for representing users or profiles
 */
export const UserIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
      <circle cx="12" cy="7" r="4"></circle>
    </Icon>
  );
};

export default UserIcon;
